/* @ngInject */
function trusted ($sce) {
  return function (text) {
    return $sce.trustAsHtml(text)
  }
}

export { trusted }
